<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import dealList from "./deal-list";
export default {
  components: { Layout, PageHeader, dealList },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <deal-list />
  </Layout>
</template>